var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.959,
    height: 20.408,
    viewBox: "0 0 22.959 20.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning_3_",
    "data-name": "warning (3)",
    transform: "translate(-19.072 -22.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38048",
    "data-name": "Path 38048",
    d: "M28.856,23.687l-9.521,16.49a1.959,1.959,0,0,0,1.7,2.939H40.073a1.959,1.959,0,0,0,1.7-2.939l-9.52-16.49a1.959,1.959,0,0,0-3.392,0Z",
    transform: "translate(0 0)",
    fill: "#e85c5c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13274",
    "data-name": "Group 13274",
    transform: "translate(29.321 28.773)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4626",
    "data-name": "Rectangle 4626",
    width: 2.463,
    height: 7.507,
    rx: 1.231,
    transform: "translate(0 0)",
    fill: "#fff7ed"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2652",
    "data-name": "Ellipse 2652",
    cx: 1.231,
    cy: 1.231,
    r: 1.231,
    transform: "translate(0 9.241)",
    fill: "#fff7ed"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/Warning-icon.6ed96af2.svg";
export { ForwardRef as ReactComponent };